module.exports = __webpack_public_path__ + "img/dao2.06b3a036.svg";